import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useNav } from "@/context/NavContext";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { items } = useNav();
  const openOrder = () => { setOpen(false); navigate("/beauftragen"); };

  const links = [
    { label: "Startseite", to: "/" },
    ...items.filter((i) => i.visible).sort((a, b) => a.order - b.order).map((i) => ({ label: i.label, to: i.route })),
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const cls = ({ isActive }) =>
    `text-sm transition-colors duration-300 ${isActive ? "text-white" : "text-[#a5a5a5] hover:text-white"}`;

  return (
    <motion.header initial={{ y: -80, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }} className="fixed top-0 left-0 right-0 z-50" data-testid="navbar">
      <div className={`transition-[background-color,padding,border-color] duration-500 border-b ${scrolled ? "bg-[#050505]/85 py-3 border-white/8" : "bg-transparent py-6 border-transparent"}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
          <Link to="/" data-testid="logo" className="font-display text-2xl tracking-tight text-white flex items-center gap-2">
            <span className="inline-block w-2 h-2 rounded-full bg-white" /> G-Repair
          </Link>
          <nav className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} className={cls} data-testid={`nav-${l.to.replace("/", "") || "home"}`}>{l.label}</NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <button onClick={openOrder} data-testid="nav-book-btn" className="hidden sm:inline-flex items-center rounded-full bg-white text-[#050505] text-sm font-medium px-5 py-2.5 hover:bg-[#d1d5db] transition-colors duration-300">
              Reparatur beauftragen
            </button>
            <button onClick={() => setOpen((o) => !o)} className="md:hidden text-white text-sm font-mono" data-testid="mobile-menu-toggle">{open ? "Schließen" : "Menü"}</button>
          </div>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="md:hidden glass overflow-hidden">
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)} className="text-[#ccc] hover:text-white transition-colors">{l.label}</NavLink>
              ))}
              <button onClick={openOrder} data-testid="nav-book-btn-mobile" className="inline-flex items-center justify-center rounded-full bg-white text-[#050505] text-sm font-medium px-5 py-3 hover:bg-[#d1d5db] transition-colors duration-300">
                Reparatur beauftragen
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
